<template>
  <div class="width">
    <v-card class="elevation-12 degrade-background-sebrae cardzao">
      <div class="logo">Selo Sebrae de Referência em Atendimento</div>
      <div class="logo insc">Inscrição 2026</div>

      <div class="cardAqui">
        <div class="medalhas left">
          <img
            :src="getSeloImageUrl(MEDAL_TYPES.BRONZE)"
            @error="handleSeloImageError($event, MEDAL_TYPES.BRONZE)"
          />
          <img
            :src="getSeloImageUrl(MEDAL_TYPES.PRATA)"
            @error="handleSeloImageError($event, MEDAL_TYPES.PRATA)"
          />
        </div>
        <div class="medalhas right">
          <img
            :src="getSeloImageUrl(MEDAL_TYPES.OURO)"
            @error="handleSeloImageError($event, MEDAL_TYPES.OURO)"
          />
          <img
            :src="getSeloImageUrl(MEDAL_TYPES.DIAMANTE)"
            @error="handleSeloImageError($event, MEDAL_TYPES.DIAMANTE)"
          />
        </div>
        <div class="formulario">
          <slot name="formulario"></slot>
        </div>
      </div>
    </v-card>
  </div>
</template>
<script>
import seloImageMixin from "@/mixins/seloImageMixin";

export default {
  mixins: [seloImageMixin],
};
</script>
<style lang="scss" scoped>
@import "@/variables.scss";

.cardzao {
  min-height: 400px;
  min-width: 650px;

  max-width: 700px;
  height: fit-content;
}
.width {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.formulario {
  margin: 0 auto;
  width: 60%;
}

@media screen and (max-width: 770px) {
  .cardzao {
    min-height: 400px;
    min-width: 100%;
  }
  .width {
    max-width: 100%;
    margin: 0;
  }

  .formulario {
    margin: 0 auto;
    width: 90%;
  }
}

.cardAqui {
  position: relative;
  padding-bottom: 1rem;
}
.logo {
  display: flex;
  justify-content: center;
  align-items: center;
  color: $cor-selo-texto;
  font-size: 24px;
  font-weight: bold;
  padding: 2rem 1rem 1rem 1rem;
  text-align: center;
}

.insc {
  padding: 0 1rem 1rem 1rem;
}

.logoImg {
  width: 350px;
  margin-top: 20px;
}

.medalhas {
  position: absolute;
  display: flex;
  top: 0;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  img {
    width: 110px;
  }
  &.left {
    left: 0;
    margin-left: 10px;
  }

  &.right {
    right: 0;
    margin-right: 10px;
  }
}
</style>
